import React, { useContext, useEffect, useState } from "react";
import { AppContext, AuthContext } from "App";
import Cookies from "js-cookie";

import {
  FaArrowAltCircleLeft,
  FaChevronDown,
  FaChevronUp,
  FaUser,
  FaUserAlt,
  FaUserCircle,
} from "react-icons/fa";
import PopupWindow from "components/PopupWindow";
import LoginMenu from "./LoginMenu";
import { PublicDataContext } from "pages/PublicData";

function Login({ triggerOpen }) {
  const auth = useContext(AuthContext);
  const publicDataContext = useContext(PublicDataContext);
  const appContext = useContext(AppContext);

  //popup states
  const [popupOpen, _setPopupOpen] = useState(false);
  const setPopupOpen = (newState) => {
    _setPopupOpen(newState);
    setError("");
    setSuccess("");
  };
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    if (triggerOpen) setPopupOpen(true);
  }, [triggerOpen]);

  const handleLogout = () => {
    auth.setAuth(null);
    Cookies.remove("accessToken");
    Cookies.remove("refreshToken");
    Cookies.remove("email");
    publicDataContext.setSelectedDevices([]);
    publicDataContext.setUserDevicesOriginal([]);
  };

  return (
    <div>
      {auth.auth?.email ? (
        <div
          style={{
            display: "flex",
            color: "white",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            padding: 10,
            height: 40,
            border: "1px solid white",
            borderRadius: 10,
            gap: 20,
            cursor: "pointer",
            background: appContext.fullscreenMap
              ? "#436c9a"
              : "rgba(0, 0, 0, 0)",
            zIndex: 100,
          }}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <FaUser />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 10,
              height: "100%",
              marginTop: -3,
            }}
          >
            <p
              style={{
                fontSize: 20,
              }}
            >
              User Menu
            </p>{" "}
            {dropdownOpen ? <FaChevronUp /> : <FaChevronDown />}
          </div>
          {dropdownOpen && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                position: "absolute",
                top: 100,
                right: 25,
                // width: 300,
                background: "#1e374f",
              }}
            >
              <div
                style={{
                  padding: 10,
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  borderBottom: "1px solid white",
                  cursor: "auto",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <FaUserAlt /> {auth.auth?.email}
              </div>
              <div
                style={{
                  padding: 10,
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                }}
                onClick={() => {
                  handleLogout();
                }}
              >
                <FaArrowAltCircleLeft /> Logout
              </div>
            </div>
          )}
        </div>
      ) : (
        <button
          style={{
            padding: "10px",
            width: 150,
            backgroundColor: "#0b1826",

            marginRight: 10,
            borderRadius: "5px",
            color: "white",
            border: "1px solid white",
            boxSizing: "border-box",
          }}
          onClick={() => {
            setPopupOpen(true);
          }}
        >
          <FaUserCircle />
          {"     "}
          Sign In / Sign Up
        </button>
      )}

      <PopupWindow
        setOpen={setPopupOpen}
        open={popupOpen}
        style={{
          background: "#ffffff",
          color: "black",
        }}
      >
        <LoginMenu
          callback={(response) => {
            console.log("Callback from LoginMenu:", response);
            if (response.success) {
              setSuccess(response.message);
              setError("");
            } else if (!response.success) {
              setSuccess("");
              setError(response.error);
            }

            setPopupOpen(false);
          }}
          setError={(error) => {
            setError(error?.message || error);
            setSuccess("");
          }}
        />
        {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
        {success && (
          <p style={{ color: "#436c9a", textAlign: "center" }}>{success}</p>
        )}
      </PopupWindow>
    </div>
  );
}

export default Login;
